module.exports = __webpack_public_path__ + "img/fixed_menu_logo.54f2b2dd.png";